import { render, staticRenderFns } from "./SubtitlesPresetsDialog.vue?vue&type=template&id=6d8afff4&scoped=true"
import script from "./SubtitlesPresetsDialog.vue?vue&type=script&lang=js"
export * from "./SubtitlesPresetsDialog.vue?vue&type=script&lang=js"
import style0 from "./SubtitlesPresetsDialog.vue?vue&type=style&index=0&id=6d8afff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8afff4",
  null
  
)

export default component.exports